function toggleRotate(context, event, actionMeta) {
  context.itkVtkView.setRotate(context.main.rotateEnabled)
}

export default toggleRotate
